// Product ceiling for a room's participant limit (the form's slider goes from
// "no limit" through 1..99). Self-hosted LiveKit would allow ~3,000.
export const MAX_ROOM_PARTICIPANTS = 99;
